import Types from './Types';

const INITIAL_STATE = {
    questionsBank: [],
    questionBank: {},
    topMissedQuestions: [],
    isLoading: false,
    suspendLoading: false,
    bookmarkLoading: false,
    updateTagsLoading: false,
    count: ''
};

export default function questionsBank(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_QUESTIONS_BANK_SUCCESS: {
            return {
                ...state,
                questionsBank: payload.data,
                count: payload.data.length
            };
        }

        case Types.GET_QUESTION_BANK_SUCCESS: {
            return {
                ...state,
                questionBank: payload
            };
        }

        case Types.EDIT_QUESTION_BANK_SUCCESS: {
            let data = payload.data;
            const questionsBank = state.questionsBank;
            let idx = 0;
            questionsBank.forEach((table, index) => {
                if (table.id === data.id) {
                    idx = index;
                    return;
                }
            });

            questionsBank[idx] = data;
            return {
                ...state,
                questionsBank: questionsBank
            };
        }

        // create
        case Types.CREATE_QUESTION_BANK_SUCCESS: {
            const data = payload.data.data;
            let newArray = state.questionsBank.slice();
            let index = state.questionsBank.length + 1;
            newArray.splice(index, 0, data);
            return {
                ...state,
                questionsBank: newArray
            };
        }
        case Types.ADD_QUESTION_BANK_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.DELETE_QUESTION_BANK_SUCCESS: {
            let id = payload.payload;
            let data = payload.result.data.data

            const questionsBank = state.questionsBank;
            let idx = 0;
            questionsBank.forEach((table, index) => {
                if (table.id === id) {
                    idx = index;
                    return;
                }
            });

            questionsBank[idx].deleted_at = data?.deleted_at;
            return {
                ...state,
                questionsBank: questionsBank
            };
        }

        case Types.HARD_DELETE_QUESTION_BANK_SUCCESS: {
            const id = payload;
            const next = state.questionsBank.filter(
                (item) => String(item.id) !== String(id)
            );
            return {
                ...state,
                questionsBank: next,
                count: next.length
            };
        }

        case Types.BOOKMARK_QUESTION_BANK_SUCCESS: {
            let id = payload.payload;
            let data = payload.result.data.data
            const questionsBank = state.questionsBank;
            let idx = 0;
            questionsBank.forEach((table, index) => {
                if (table.id === id) {
                    idx = index;
                    return;
                }
            });

            questionsBank[idx].book_marked = data?.book_marked;
            return {
                ...state,
                questionsBank: questionsBank
            };
        }




        case Types.BOOKMARK_QUESTION_BANK_LOADING: {
            return {
                ...state,
                bookmarkLoading: payload
            };
        }

        case Types.SUSPEND_QUESTION_BANK_LOADING: {
            return {
                ...state,
                suspendLoading: payload
            };
        }

        case Types.GET_TOP_MISSED_QUESTIONS_FOR_ADMIN_SUCCESS: {
            return {
                ...state,
                topMissedQuestions: payload.data
            };
        }

        case Types.UPDATE_QUESTION_TAGS_SUCCESS: {
            const updatedQuestion = payload.data || payload;
            const questionId = updatedQuestion.id;
            
            // Update topMissedQuestions if the question exists there
            const updatedTopMissedQuestions = state.topMissedQuestions.map((item) => {
                const question = item.question || item;
                if (question.id === questionId) {
                    // If item has a question property, update it; otherwise update the item itself
                    if (item.question) {
                        return {
                            ...item,
                            question: {
                                ...question,
                                tags: updatedQuestion.tags || question.tags
                            }
                        };
                    } else {
                        return {
                            ...item,
                            tags: updatedQuestion.tags || question.tags
                        };
                    }
                }
                return item;
            });

            return {
                ...state,
                questionBank: updatedQuestion,
                topMissedQuestions: updatedTopMissedQuestions
            };
        }

        case Types.UPDATE_QUESTION_TAGS_LOADING: {
            return {
                ...state,
                updateTagsLoading: payload
            };
        }

        default: {
            return state;
        }
    }
}
